<template>
  <div style="margin-top: -12px">
    <v-container fluid>
      <v-card flat class="disable-scrollbars">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              dark
              v-bind="attrs"
              v-on="on"
              bottom
              right
              class="float-right mx-4"
              color="blue-grey"
              style="position: relative; margin-top: -60px"
              @click="
                () => {
                  $router.go(-1);
                }
              "
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </template>
          <span>Voltar</span>
        </v-tooltip>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            single-line
            hide-details
            class="mx-4"
          >
          </v-text-field>
        </v-card-title>
        <v-card-text>
          <div style="clear: both"></div>
          <template>
            <v-data-table
              :headers="headers"
              :items-per-page="10"
              :hide-default-footer="footeHiden"
              :disable-pagination="paginat"
              :search="search"
              loading-text="A carregar"
              :items="getInvoiceDisputeInStore"
            >
              <template v-slot:item.invoiceUUID="{ item }">
                <v-chip
                  :color="getColor('Transferir')"
                  @click="printInvoice(item.invoiceUUID)"
                  dark
                  outlined
                  label
                  style="width: 105px"
                >
                  <v-icon left size="16">{{ getIcon("Transferir") }}</v-icon>
                  <span>Transferir</span>
                </v-chip>
              </template>
              <template v-slot:item.totalAmount="{ item }">
                <span :style="getColorMount(item.totalAmount)">
                  {{ new Intl.NumberFormat("de-DE").format(item.totalAmount) }}
                  {{ currency }}
                </span>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip
                  :color="getColorStatus(item.status)"
                  dark
                  label
                  style="width: 80px"
                >
                  <span>Disputa</span>
                </v-chip>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapHelperEnterprise } from "@/store/helperEnterprise";

export default {
  name: "AnalyzeComponent",
  data() {
    return {
      paginat: false,
      search: "",
      footeHiden: false,
      currency: "Akz",
      headers: [
        {
          text: "PERÍODO",
          align: "start",
          sortable: false,
          value: "period"
        },
        { text: "REFERÊNCIA DA FACTURA", value: "invoiceRef" },
        { text: "MONTANTE", value: "totalAmount" },
        { text: "ESTADO", value: "status", sortable: false },
        { text: "TRANSFERIR", value: "invoiceUUID", sortable: false }
      ]
    };
  },
  methods: {
    getColor(type) {
      if (type === "Transferir") return "green";
    },
    getIcon(type) {
      if (type === "Transferir") return "mdi-download";
    },
    getColorMount(type) {
      if (type > 30000) return "color:green";
      else return "color:#1976d2c4";
    },
    getColorStatus(type) {
      if (type === "Aberto") return "red";
      else if (type === "Fechado") {
        return "green";
      } else return "orange";
    },
    printInvoice(type) {
      return type;
    }
  },
  computed: {
    ...mapHelperEnterprise
  }
};
</script>

<style scoped></style>
